module.exports = __webpack_public_path__ + "static/media/zh.02c229de.svg";